import { makeStyles } from "@material-ui/core";
import { checkboxClasses } from "@mui/material";

export const DEFAULT_LOCALE = 'en-IN'
export const INR_CURRENCY_STYLE = { style: 'currency', currency: 'INR', minimumFractionDigits: 2 }
export const WEBSOCKET_URL = "/algo-trading/ws";

export const randomNumber = () => {
  return Math.random() * 1000;
}

export const ROLE = {
  ADMIN: 'ADMIN',
  FNO_ADMIN: 'FNO_ADMIN',
  CUSTOMER: 'CUSTOMER',
}

export const BROKER = {
  ANGEL_ONE: 'ANGEL_ONE',
  DHAN: 'DHAN',
  KOTAK: 'KOTAK',
  PAPER: 'PAPER',
  ZERODHA: 'ZERODHA',
  PROSTOCKS: 'PROSTOCKS',
}

export const TRADE_SWITCH_TYPE = {
  DAY_TRADE: 'DAY_TRADE',
}


export const formatToLakhsCrores = (number) => {
  return new Intl.NumberFormat(DEFAULT_LOCALE, {
    style: 'currency',
    currency: "INR",
    notation: 'compact',
    compactDisplay: 'long',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(number).replace("T", "K");
}

export const formatNumbersToLongFormat = (number) => {
  return new Intl.NumberFormat(DEFAULT_LOCALE, {
    currencyDisplay: 'symbol',
    style: 'currency',
    currency: "INR",
    compactDisplay: 'long',
    maximumFractionDigits: 0
  }).format(number);
}
export const formatMoney = (number) => {
  return new Intl.NumberFormat(DEFAULT_LOCALE, {
    style: 'decimal',
    currency: "INR",
    compactDisplay: 'long',
    maximumFractionDigits: 0
  }).format(number);
}

export const stringToLong = (str) => {
  try {
    return Number(str);
  } catch (error) {
    return NaN; // Handle cases where the string is not a valid number
  }
};

export function getNumber(value) {
  return value ? Number(value) : 0;
}

export const commonStyle = (theme) => {
  return ({
    menuItem: {
      display: 'block',
      blockSize: 'auto'
    },
    profit: {
      color: 'green'
    },
    loss: {
      color: 'red'
    },
    marketScore: {
      backgroundColor: '#1976d2',
      color: 'white'
    }
  })
}

export const multipleOfUnitFloor = (value, unit) => {
  if (!unit || unit === 0 || !value) {
    return "";
  }
  const division = value / unit;
  if (division - Math.floor(division) === 0.5) {
    return Math.floor(division) * unit;
  }
  return Math.round(division) * unit;
}

export const hasActiveUsers = (selectedUsers, setWarningMessage, setOpen) => {
  const activeUsers = Array.isArray(selectedUsers) ? selectedUsers.filter(u => u.active) : [];
  if (!activeUsers || activeUsers.length === 0) {
    setWarningMessage("Please select active users");
    setOpen(true);
    return false;
  }
  return true;
};

export const useSharedStyles = makeStyles({
  profit: {
    color: 'green'
  },
  loss: {
    color: 'red'
  },
  bullishButton: {
    borderRadius: 35,
    backgroundColor: "forestgreen",
    padding: "6px 12px",
    fontSize: "13px"
  },
  bearishButton: {
    borderRadius: 35,
    backgroundColor: "red",
    padding: "6px 12px",
    fontSize: "13px"
  },
  bullishTick: {
    color: "blue",
    [`&.${checkboxClasses.checked}`]: {
      color: 'blue',
    }
  },
  bearishTick: {
    color: "red",
    [`&.${checkboxClasses.checked}`]: {
      color: 'red',
    }
  },
  form: {
    display: 'flex',
    flexFlow: 'column',
    height: '100%',
    width: '100%',
  },
});